import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { supabase } from '../supabaseClient';
import { useDestrierTheme } from '../ThemeContext';

export default function AuthCallback() {
  const { c } = useDestrierTheme();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Confirming your account...');

  useEffect(() => {
    // Sign out any session (user should manually log in after confirming)
    supabase.auth.signOut().then(() => {
      setMessage('Email confirmed! Redirecting to login...');
      setTimeout(() => navigate('/login', { replace: true }), 1500);
    });
  }, [navigate]);

  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundColor: c.bg,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
    }}>
      <CircularProgress sx={{ color: c.accent }} />
      <Typography sx={{ color: c.textMuted, fontSize: '0.95rem' }}>
        {message}
      </Typography>
    </Box>
  );
}
